import axiosClient from "./axiosClient";

export const apiUrl = process.env.REACT_APP_API_BASE_URL;

//Usuários
export const urlLoginUsuario = apiUrl + "usuarios/entrar/adicionar";
export const urlCadastrarUsuario = apiUrl + "usuarios/cadastrar/adicionar";
export const urlCodigoVerificacaoUsuario =
  apiUrl + "usuarios/codigo_verificacao/listar";
export const urlInfoContaUsuario = apiUrl + "usuarios/consultas/conta";
export const urlHorariosAtendimentoUsuario =
  apiUrl + "usuarios/agendar/horario_atendimento";
export const urlHorariosDisponiveisAgendamentoUsuario =
  apiUrl + "/usuarios/agendamentos/horarios_servicos_removidos";
export const urlServicosAgendamentoUsuario =
  apiUrl + "usuarios/consultas/servicos";
export const urlCancelarAgendamentoUsuario =
  apiUrl + "usuarios/agendamentos/cancelar";
export const urlAgendamentosDiaUsuario = apiUrl + "usuarios/inicio/resumo";
export const urlContaUsuario = apiUrl + "usuarios/consultas/conta";
export const urlEnviarCodigoPerfilUsuario = apiUrl + "usuarios/inicio/listar";
export const urlAtualziarCodigoPerfilUsuario =
  apiUrl + "usuarios/inicio/editar";

//Empresas
export const urlLoginEmpresas = apiUrl + "empresas/entrar/adicionar";
export const urlCadastrarEmpresas = apiUrl + "empresas/cadastrar/adicionar";
export const urlCodigoVerificacaoEmpresas =
  apiUrl + "empresas/codigo_verificacao/listar";
export const urlInfoContaEmpresas = apiUrl + "empresas/consultas/conta";
export const urlHorariosAtendimentoEmpresas =
  apiUrl + "empresas/agendar/horario_atendimento";
export const urlHorariosDisponiveisAgendamentoEmpresas =
  apiUrl + "/empresas/agendamentos/horarios_servicos_removidos";
export const urlServicosAgendamentoEmpresas =
  apiUrl + "empresas/consultas/servicos";
export const urlCancelarAgendamentoEmpresas =
  apiUrl + "empresas/agendamentos/cancelar";
export const urlAgendamentosDiaEmpresas = apiUrl + "empresas/inicio/resumo";
export const urlContaEmpresas = apiUrl + "empresas/consultas/conta";
export const urlEnviarCodigoPerfilEmpresas = apiUrl + "empresas/conta/listar";
export const urlAtualziarCodigoPerfilEmpresas =
  apiUrl + "empresas/conta/editar";
export const urlClientesAgendamento = apiUrl + "empresas/consultas/clientes";
export const urlAssinarPlano = apiUrl + "empresas/inicio/adicionar";
export const urlListarCalendario = apiUrl + "empresas/calendario/listar";
export const urlListarCalendarioAgenda =
  apiUrl + "empresas/calendario/listar_calendario";
export const urlAgendamentosAlterarStatus =
  apiUrl + "empresas/agendamentos/editar_status";

export const urlAgendamentosPorDia = apiUrl + "empresas/dashboard/listar";
export const urlResumoMensalConta =
  apiUrl + "empresas/consultas/resumo_conta_mensal";

export const menuItems = [
  {
    path: "/empresas/dashboard",
    icon: "ri-pie-chart-line",
    label: "Dashboard",
  },
  {
    path: "/empresas/calendario",
    icon: "ri-calendar-check-line",
    label: "Calendário/Agenda",
  },
  { path: "/empresas/agendar", icon: "ri-add-line", label: "Agendar horário" },
  {
    path: "/empresas/agendamentos-dia",
    icon: "ri-calendar-event-fill",
    label: "Agendamentos do dia",
  },
  {
    path: "/empresas/dias_nao_atendidos",
    icon: "ri-calendar-close-fill",
    label: "Dias não atendidos",
  },
  {
    path: "/empresas/dias_excessao",
    icon: "ri-calendar-close-fill",
    label: "Datas de exceção",
  },
  {
    path: "/empresas/configuracoes_horario_atendimento",
    icon: "ri-calendar-schedule-line",
    label: "Horário de atendimento",
  },
  { path: "/empresas/servicos", icon: "ri-store-line", label: "Serviços" },
  { path: "/empresas/clientes", icon: "ri-user-line", label: "Clientes" },
  {
    path: "logout",
    icon: "ri-logout-box-line",
    label: "Desconectar",
    action: null,
  },
];
export const urlValoresMensal = apiUrl + "empresas/dashboard/valores_reais";
//Token
export let modoDev = false;
const locationAtual = window.location.host;
if (locationAtual.includes("3000")) {
  modoDev = true;
}


export const urlListarValoresAgendamento = apiUrl + "empresas/atualizar_valores/listar";
export const urlAtualizarValoresAgendamento = apiUrl + "empresas/atualizar_valores/atualizar";
// Gráficos usuários
export const urlGraficoTotalAgendamentosUsuario =
  apiUrl + "usuarios/inicio/grafico_total_agendamentos";

//Urls base
export const urlListar = (tipoUsuario, tipoTela) => {
  return apiUrl + `${tipoUsuario}/${tipoTela}/listar`;
};
export const urlAdicionar = (tipoUsuario, tipoTela) => {
  return apiUrl + `${tipoUsuario}/${tipoTela}/adicionar`;
};
export const urlInformacoes = (tipoUsuario, tipoTela, params) => {
  return apiUrl + `${tipoUsuario}/${tipoTela}/get_id?${params}`;
};
export const urlAlterar = (tipoUsuario, tipoTela) => {
  return apiUrl + `${tipoUsuario}/${tipoTela}/editar`;
};
export const urlApagar = (tipoUsuario, tipoTela) => {
  return apiUrl + `${tipoUsuario}/${tipoTela}/apagar`;
};

//Sessão do usuário

export const carregarSessao = async () => {
  let telaAtual = window.location.pathname.split("/")[1];
  if (telaAtual === "empresa") {
    telaAtual = "usuarios";
  }
  try {
    const response = await axiosClient.post(
      apiUrl + telaAtual + "/sessao/sessao",
      {}
    );
    if (response.data === 1) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

const verificarSessao = async () => {
  const params = new URLSearchParams(window.location.search);
  const empresaParam = params.get("empresa");

  let telaAtualInicial = window.location.pathname.split("/")[1];
  let telaAtual = window.location.pathname.split("/")[2];
  if (telaAtualInicial === "empresa") {
     window.location.href = `/usuarios/login?empresa=${empresaParam}`;
    return;
  }
  if (telaAtualInicial.length === 0) {
    return;
  }
  let sessao = await carregarSessao();
  if (
    !sessao &&
    telaAtual !== "cadastrar" &&
    telaAtual !== "login" &&
    telaAtual !== "codigo_verificacao"
  ) {
    window.location.href = `/${telaAtualInicial}/login`;
  }
};

verificarSessao();
